import api from "./axios";

export const getRoles = async () => {
  const response = await api.get("/roles");
  return response.data;
};

export const createRole = async (roleName) => {
  const response = await api.post("/roles", { role_name: roleName });
  return response.data;
};

export const updateRole = async (roleId, roleName) => {
  const response = await api.patch("/roles/" + roleId, {
    role_name: roleName,
  });
  return response.data;
};

export const deleteRole = async (roleId) => {
  const response = await api.delete("/roles/" + roleId);
  return response.data;
};

export const addPermissionToRole = async (roleId, permissionId) => {
  const response = await api.post("/roles/" + roleId + "/permissions", {
    permission_id: permissionId,
  });
  return response.data;
};

export const removePermissionFromRole = async (roleId, permissionId) => {
  const response = await api.delete(
    "/roles/" + roleId + "/permissions/" + permissionId,
  );
  return response.data;
};
